import { Button } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { isSessionEnded, isUnavailable } from "../isInSession";
import { useGetSessionQuery, useGetUserInfoQuery } from '../services/api';

export function JoinButton({
  guid,
  inSession,
}: {
  guid?: string;
  inSession: boolean;
}) {
  const navigate = useNavigate();
  const { data: session } = useGetSessionQuery(guid);
  const { data: user } = useGetUserInfoQuery();

  if (!inSession) {
    return null;
  }
  if (isSessionEnded(session)) {
    return null;
  }

  return (
    <Button
      disabled={isUnavailable(session, user?.role)}
      fullWidth
      onClick={() => navigate(`/room/${session?.guid}`)}
      variant='contained'
    >Join Session</Button>
  );
}
